module.exports = __webpack_public_path__ + "static/extreme-ownership-7e7724405fba675fe707d5311592015b.jpg";